import React, { Component } from 'react';
import FilterResults from './filterResults';
import EngineApplication from './EngineApplication';
import OtherApplication from './OtherApplication';
import { I18n, translate } from 'react-i18next';
const Fragment = React.Fragment;

class ResultList extends Component {
  constructor(props) {
    super(props);
    

    const { i18n, t, equipment } = this.props;
    let applications = this.getApplicationsFromEquipment(equipment.applications);    
    const engineApplicationName = i18n.language === 'is' || i18n.language === 'nl-be' ? 'Engine' : t('vehicle_spec.engine');
    const engineApplication = this.filterArray(applications, engineApplicationName);

    this.state = {
      applications,
      engineApplicationName,
      engineApplication,
      hasEngine: !!engineApplication.length,
      hideEngine: false,
    };
  }

  updateResults = (results) => {
    const { engineApplicationName } = this.state;
    const inResults = this.filterArray(results, engineApplicationName) || [];
    const hideEngine = this.state.hasEngine && !inResults.length;

    this.setState({
      applications: results,
      hideEngine,
    });
  };

  filterArray = (arr, value) => {
    return arr.filter((obj) => {
      return obj.name && obj.name.trim() === value.trim();
    });
  };

  getApplicationsFromEquipment = (applications) => {
    //get uniques application names
    let uniques = applications.map((x) => x.name).filter((v, i, a) => a.indexOf(v) === i);
    let sortedApplications = [];

    uniques.forEach(function(name) {
      sortedApplications.push({ name: name, applications: this.filterArray(applications, name) });
    }, this);

    return sortedApplications;
  };

  render() {
    const { engineApplicationName, engineApplication, hideEngine, applications } = this.state;
    const { showFilter, selectedFamily, equipment, selectedEngineOption } = this.props;
    return (
      <I18n ns="translations">
        {(t) => (
          <Fragment>
            {showFilter && (
              <FilterResults
                updateResults={this.updateResults}
                applications={applications}
                equipment={equipment}
                selectedFamily={selectedFamily}
              />
            )}
            <section className="list">
              {!hideEngine && (
                <EngineApplication
                  key={engineApplication[0] ? engineApplication[0].name : null}
                  application={engineApplication[0]}
                  t={t}
                  selectedEngineOption={selectedEngineOption}
                  {...this.props}
                />
              )}
              {applications.map((application) => {
                return (
                  application.name !== engineApplicationName && (
                    <OtherApplication
                      key={application.name}
                      application={application}
                      equipment={equipment}
                      t={t}
                    />
                  )
                );
              })}
            </section>
          </Fragment>
        )}
      </I18n>
    );
  }
}

export default translate('translations')(ResultList);



// WEBPACK FOOTER //
// ./src/components/results/resultList.js